var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[(_vm.getAllDevices.length === 0)?_c('div',[_c('no-device')],1):_c('div',_vm._l((_vm.getAllDevices),function(device){return _c('div',{key:device.id},[_c('overview-card',{attrs:{"device":device}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }